module.exports = __webpack_public_path__ + "img/korhaz-logo.956ab697.jpg";